import {GameStatus} from "../model/gameStatus";
import {ODK} from "../model/odk";
import {PlayType} from "../model/playType";
import {PlayResult} from "../model/playResult";
import {Hash} from "../model/hash";
import {GamePlay} from "../model/game-play";
import {LineUp} from "../model/lineUp";
import {Player, UpdatePlayerLineUpDialog} from "../model/players";
import {GameInfo} from "../model/game";
import {Position} from "../model/position";
import {GameType} from "../model/gameType";

export const fakeGame: GameInfo = {
  id: '1111',
  gameDate: '2023-05-01',
  gameTime: '20:00:00',
  homeTeam: {
    "id": "2",
    "teamName": "Les Escargots enflamées",
    "teamLogo": "demo.png",
    "teamShortName": "Escargots",
    "teamNameAbr": "Esc",
    "teamLeague": {
      id: "fake",
      name: "fake",
      shortName: "fake"
    },
    teamLogoUrl: "https://imgur.com/Kjevqsf",
    isPayingTeam: true
  },
  awayTeam: {
    "id": "1",
    "teamName": "Les Pintades enragées",
    "teamLogo": "demo.png",
    "teamShortName": "Pintades",
    "teamNameAbr": "Pin",
    "teamLeague": {
      id: "fake",
      name: "fake",
      shortName: "fake"
    },
    teamLogoUrl: "https://imgur.com/Kjevqsf",
    isPayingTeam: false
  },
  homeScore: 21,
  awayScore: 17,
  rseqNumber: 101,
  gameStatus: GameStatus.Pending,
  numberOfDowns: 4,
  gameType: GameType.Season,
  seasonId: "season demo"
}

export const fakeGamePlayList1: GamePlay[] = [
  {
    _status: GameStatus.Completed,
    odk: ODK.Kick,
    "down": 0,
    "distance": 0,
    "hash": Hash.L,
    "gnLs": 0,
    "yardLine": "-45",
    "kickYards": 35,
    "returnYards": 18,
    "kicker": 7,
    "returner": 6,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 2,
    "down": 1,
    "hash": Hash.L,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    playType: PlayType.Pass,
    result: PlayResult.Complete,
    "passer": 2,
    "receiver": 9,
    "tackler1": 19,
    "qtr": 1
      }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 3,
    "down": 2,
    "hash": Hash.R,
    "yardLine": "46",
    "debug": "createNextGamePlay()",
    "distance": 8,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 5,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 3,
    "down": 3,
    "hash": Hash.R,
    "yardLine": "43",
    "debug": "createNextGamePlay()",
    "distance": 5,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 4,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 1,
    "down": 4,
    "hash": Hash.R,
    "yardLine": "40",
    "debug": "createNextGamePlay()",
    "distance": 2,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 4,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 2,
    "down": 1,
    "hash": Hash.L,
    "yardLine": "-39",
    "debug": "createNextGamePlay()",
    "distance": 10,
    playType: PlayType.Pass,
    result: PlayResult.Complete,
    "passer": 5,
    "receiver": 12,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 2,
    "down": 2,
    "hash": Hash.R,
    "yardLine": "-41",
    "debug": "createNextGamePlay()",
    "distance": 8,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 5,
    "tackler1": 19,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 0,
    "down": 3,
    "hash": Hash.M,
    "yardLine": "-43",
    "debug": "createNextGamePlay()",
    "distance": 6,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 4,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 2,
    "down": 4,
    "hash": Hash.R,
    "yardLine": "-43",
    "debug": "createNextGamePlay()",
    "distance": 6,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 25,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 1,
    "hash": Hash.M,
    "yardLine": "45",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 4,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 6,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "45",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 6,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 3,
    "hash": Hash.R,
    "yardLine": "39",
    "debug": "createNextGamePlay()",
    "distance": 4,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 12,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 4,
    "hash": Hash.M,
    "yardLine": "39",
    "debug": "createNextGamePlay()",
    "distance": 4,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 2,
    "down": 1,
    "hash": Hash.M,
    "yardLine": "-39",
    "debug": "createNextGamePlay()",
    "distance": 10,
    result: PlayResult.Complete,
    playType: PlayType.Pass,
    "passer": 3,
    "receiver": 16,
    "tackler1": 25,
    "qtr": 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 4,
    "down": 1,
    "hash": Hash.R,
    "yardLine": "-41",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 5,
    "qtr": 2
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 1,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "-45",
    "debug": "createNextGamePlay()",
    "distance": 6,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 6,
    "qtr": 2
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 1,
    "down": 3,
    "hash": Hash.R,
    "yardLine": "-46",
    "debug": "createNextGamePlay()",
    "distance": 5,
    playType: PlayType.Pass,
    result: PlayResult.Complete,
    "passer": 6,
    "qtr": 2
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Defensive,
    "gnLs": 1,
    "down": 4,
    "hash": Hash.R,
    "yardLine": "-47",
    "debug": "createNextGamePlay()",
    "distance": 4,
    "playType": PlayType.Run,
    result: PlayResult.Rush,
    "rusher": 5,
    "tackler1": 20,
    "qtr": 2
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 1,
    "hash": Hash.L,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    playType: PlayType.Pass,
    result: PlayResult.Incomplete,
    "passer": 5,
    "battedDown": 20,
    "qtr": 2
  }, {
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },
  {
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  },{
    _status: GameStatus.Pending,
    odk: ODK.Offensive,
    "gnLs": 0,
    "down": 2,
    "hash": Hash.M,
    "yardLine": "48",
    "debug": "createNextGamePlay()",
    "distance": 10,
    "qtr": 2
  }
]

export const fakeGamePlayList2: GamePlay[] = [
  {
    _status: GameStatus.Completed,
    odk: ODK.Kick,
    down: 0,
    distance: 0,
    yardLine: '-45',

    playType: PlayType.KOREC,
    result: PlayResult.Return,
    gnLs: 10,
    hash: Hash.M,
    kickYards: 33,
    returnYards: 13,
    qtr: 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    down: 1,
    distance: 10,
    yardLine: '-35',

    playType: PlayType.Run,
    result: PlayResult.Rush,
    gnLs: 10,
    hash: Hash.R,
    qtr: 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    down: 1,
    distance: 10,
    yardLine: '-45',

    playType: PlayType.Run,
    result: PlayResult.Rush,
    gnLs: 1,
    hash: Hash.M,
    qtr: 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    down: 2,
    distance: 9,
    yardLine: '-45',

    playType: PlayType.Run,
    result: PlayResult.Rush,
    gnLs: 12,
    hash: Hash.M,
    qtr: 1
  }, {
    _status: GameStatus.Completed,
    odk: ODK.Offensive,
    down: 1,
    distance: 10,
    yardLine: '53',

    playType: PlayType.Pass,
    result: PlayResult.Complete,
    gnLs: 13,
    hash: Hash.R,
    returnYards: 0,
    qtr: 1
  }
]

export const fakeGamePlayListGrasset: GamePlay[] = [{
  _status: GameStatus.Completed,
  "odk": ODK.Kick,
  "down": 0,
  "distance": 0,
  "hash": Hash.R,
  "gnLs": 0,
  "yardLine": "-45",
  "kickYards": 49,
  "returnYards": 15,
  "kicker": 9,
  "returner": 13,
  "qtr": 2
}, {
  _status: GameStatus.Completed,
  odk: ODK.Offensive,
  "gnLs": 19,
  "down": 1,
  "hash": Hash.R,
  "yardLine": "31",
  "debug": "createNextGamePlay()",
  "distance": 10,
  playType: PlayType.Pass,
  result: PlayResult.Complete,
  "passer": 2,
  "receiver": 12,
  "qtr": 2
}, {
  _status: GameStatus.Completed,
  odk: ODK.Offensive,
  "gnLs": 2,
  "down": 1,
  "hash": Hash.L,
  "yardLine": "12",
  "debug": "createNextGamePlay()",
  "distance": 10,
  "playType": PlayType.Run,
  result: PlayResult.Rush,
  "rusher": 4,
  "qtr": 2
}, {
  _status: GameStatus.Completed,
  odk: ODK.Offensive,
  "gnLs": 9,
  "down": 2,
  "hash": Hash.L,
  "yardLine": "10",
  "debug": "createNextGamePlay()",
  "distance": 8,
  playType: PlayType.Pass,
  result: PlayResult.Complete,
  "passer": 2,
  "receiver": 12,
  "qtr": 2
}, {
  _status: GameStatus.Pending,
  odk: ODK.Offensive,
  "gnLs": 0,
  "down": 1,
  "hash": Hash.M,
  "yardLine": "1",
  "debug": "createNextGamePlay()",
  "distance": 10,
  "qtr": 2
}]

export const fakeFullTeamLineUp: Player[] = [
    {
      "id": "001",
      "fullName": "Joueur 1",
      "jerseyNumber": 1,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 1
        }
      ],
      "playerPositions": [
        {
          "position": "QB"
        }
      ]
    },
    {
      "id": "002",
      "fullName": "Joueur 2",
      "jerseyNumber": 2,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 2
        }
      ],
      "playerPositions": [
        {
          "position": "RB"
        }
      ]
    },
    {
      "id": "003",
      "fullName": "Joueur 3",
      "jerseyNumber": 3,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 3
        }
      ],
      "playerPositions": [
        {
          "position": "WR"
        }
      ]
    },
    {
      "id": "004",
      "fullName": "Joueur 4",
      "jerseyNumber": 4,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [],
      "playerPositions": [
        {
          "position": "WR"
        }
      ]
    },
    {
      "id": "005",
      "fullName": "Joueur 5",
      "jerseyNumber": 5,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 5
        }
      ],
      "playerPositions": [
        {
          "position": "OL"
        }
      ]
    },
    {
      "id": "006",
      "fullName": "Joueur 6",
      "jerseyNumber": 6,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 6
        }
      ],
      "playerPositions": [
        {
          "position": "DL"
        }
      ]
    },
    {
      "id": "007",
      "fullName": "Joueur 7",
      "jerseyNumber": 7,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 7
        }
      ],
      "playerPositions": [
        {
          "position": "DL"
        }
      ]
    },
    {
      "id": "008",
      "fullName": "Joueur 8",
      "jerseyNumber": 8,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 8
        }
      ],
      "playerPositions": [
        {
          "position": "DB"
        }
      ]
    },
    {
      "id": "009",
      "fullName": "Joueur 9",
      "jerseyNumber": 9,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 9
        }
      ],
      "playerPositions": [
        {
          "position": "LB"
        }
      ]
    },
    {
      "id": "010",
      "fullName": "Joueur 10",
      "jerseyNumber": 10,
      "teamId": "teamId",
      "seasonId": "seasonId",
      "gamesPlayed": [
        {
          "gameJerseyNumber": 10
        }
      ],
      "playerPositions": [
        {
          "position": "K"
        },{
          "position": "WR"
        }
      ]
    },
]

export const fakeHomeLineUp: LineUp = {
  teamId: 'teamId',
  seasonId: 'seasonId',
  kickers: [10],
  passers: [1],
  receivers: [2,3,10],
  returners: [2,3,10],
  tacklers: [6, 7, 8, 9],
  rushers: [2,3,10],
  offensive: [1, 2, 3, 5],
  defensive: [6, 7, 8, 9],
  activeStatuses: [true, true, true, false, true, true, true, true, true, true],
  fullTeam: fakeFullTeamLineUp
}

export const fakeAwayLineUp: LineUp = {
  teamId: 'teamId',
  seasonId: 'seasonId',
  kickers: [10],
  passers: [1],
  receivers: [2,3,10],
  returners: [2,3,10],
  tacklers: [6, 7, 8, 9],
  rushers: [2,3,10],
  offensive: [1, 2, 3, 5],
  defensive: [6, 7, 8, 9],
  activeStatuses: [true, true, true, false, true, true, true, true, true, true],
  fullTeam: fakeFullTeamLineUp
}

export const mockGameInfo: GameInfo = {
  id: "5ec4d82e-b14a-4d5b-b7ba-3ce15778e57c",
  rseqNumber: 101,
  gameDate: new Date().toISOString(),
  gameTime: '20:00',
  gameStatus: GameStatus.Pending,
  homeScore: 0,
  awayScore: 0,
  homeTeam: {
    id: '1',
    teamName: 'Collège Champlain',
    teamLogo: '',
    teamShortName: 'Champlain',
    teamNameAbr: 'Len',
    teamLeague: {
      id: "fake",
      name: "fake",
      shortName: "fake"
    },
    teamLogoUrl: '/assets/logos/demo.png',
    isPayingTeam: true
  },
  awayTeam: {
    id: '2',
    teamName: 'Collège André-Grasset',
    teamLogo: '',
    teamShortName: 'Grasset',
    teamNameAbr: 'Gra',
    teamLeague: {
      id: "fake",
      name: "fake",
      shortName: "fake"
    },
    teamLogoUrl: '/assets/logos/demo.png',
    isPayingTeam: false
  },
  numberOfDowns: 4,
  gameType: GameType.Exhibition,
  seasonId: "season demo"
};

export const fakeEmptyUpdatePlayerLineUpDialog: UpdatePlayerLineUpDialog ={
  isEdit: true,
  playerId: '',
  fullName: '',
  jerseyNumber: 1,
  playerPositions: [],
  gamesPlayed: [],
  teamId: '',
  seasonId: ''
}

export const fakeAddUpdatePlayerLineUpDialog: UpdatePlayerLineUpDialog ={
  isEdit: false,
  playerId: '',
  fullName: 'John Doe',
  jerseyNumber: 0,
  playerPositions: [{position: Position.RB}],
  gamesPlayed: [{gameJerseyNumber: 22}],
  teamId: '1',
  seasonId: "season"
}

export const fakeEditUpdatePlayerLineUpDialog: UpdatePlayerLineUpDialog ={
  isEdit: true,
  playerId: '1',
  fullName: 'Edit player',
  jerseyNumber: 22,
  gamesPlayed: [{gameJerseyNumber: 23}],
  playerPositions: [{position: Position.WR}],
  teamId: '1',
  seasonId: "season"
}
